/**
 * internal dependencies
 */
import { ITax } from '../../models/taxes.interface';

/**
 * Widget to display available taxes for a card group/terminal
 * 
 * @param {ITax[]} availableTaxes the available tax data
 * @param {HTMLElement} parentContainer the parent container for the generated list of elements
 * 
 * @returns void
 */
export const taxListWidget = ( availableTaxes: ITax[], parentContainer: HTMLElement ) => {
  if ( Object.keys(availableTaxes).length === 0 ) {
    const div = document.createElement('div');
    div.className = `list-results-widget no-tax-list`; 

    const span = document.createElement('span');
    span.textContent = `No taxes found`;

    div.appendChild(span);    
    parentContainer.appendChild(div); 
  } else {
    availableTaxes.forEach((e: ITax) => {
      const div = document.createElement('div');
      div.className = `list-results-widget key_${e.taxId}`; 

      const span = document.createElement('span');
      span.textContent = `Name: ${e.taxName} | Rate: ${e.taxRate}`;

      const addButton = document.createElement('a');
      addButton.className = 'aafp_btn-form btn_theme-primary get-selected-element';
      addButton.id = `aafp_add-customer-${e.taxId}`;
      addButton.textContent = 'SELECT';
      addButton.setAttribute(`data-id`, e.taxId);
      addButton.setAttribute('data-name', e.taxName);
      addButton.setAttribute('data-rate', e.taxRate)

      div.appendChild(span);
      div.appendChild(addButton);
      
      if ( availableTaxes.length > 1 ) {
        parentContainer.appendChild(div);  
      } else {
        parentContainer.prepend(div);  
      }
    });
  } 

  availableTaxes.length = 0;
}